import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { Singleton } from '../../../../core/services/Singleton';
import usePaginator from '../../../theme/Component/usePaginator';
import useModal, { MODAL_LG } from '../../../theme/Component/hooks/useModal';
import { Modal } from '../../../theme/Component/Modal';
import { BasicTable } from '../../../theme/Component/BasicTable';
import { _HealthAttentionCause, _HealthAttentionGateEntry, _HealthAttentionModality, _HealthAttentionService, _HealthAttentionSite, _HealthMedication, _HealthTechnologyType, _TriageType } from '../../../../core/services/dataBean/EntityCatalogVdos';
import { BasicButton } from '../../../theme/Component/BasicButton';
import { PharmaStateEditor } from './PharmaRecordState/PharmaStateEditor';
import { PharmaLaboratoryEditor } from './PharmaLaboratory/PharmaLaboratoryEditor';
import { PharmaCumStateEditor } from './PharmaCumState/PharmaCumStateEditor';
import { MeansAdministrationEditor } from './MeansAdministration/MeansAdministrationEditor';
import { PharmaPresentationEditor } from './PharmaPresentation/PharmaPresentationEditor';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const HealthMedicationEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_HealthMedication)
    const [id, setID] = useState(null);
    const single = Singleton.getInstance();
    const [activeIngredient, setActiveIngredient ] = useState<any>(null)
    const [form, setForm] = useState<any>({
        IDPharmaRecordState:null,
        PharmaRecordStateName:null,
        IDPharmaLaboratory:null,
        PharmaLaboratoryName:null,
        IDPharmaCumState:null,
        PharmaCumState:null,
        IDMeansAdministration:null,
        MeansAdministrationName:null,
        IDPharmaPresentation:null,
        PharmaPresentationName:null,
        IDPharmaLaboratoryVendor:null,
        PharmaLaboratoryVendorName:null
     });
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const modal = useModal("Medicamento", MODAL_LG);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDHealthMedication == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };


   useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        instance.getHealthMedicationCatalog(form.IDPharmaLaboratory,form.IDPharmaRecordState,form.IDPharmaCumState,form.IDMeansAdministration,form.IDPharmaPresentation,form.IDPharmaLaboratoryVendor,activeIngredient,regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }

    const head = [
        { title: 'ID', property: 'IDHealthMedication', visible: true },
        { title: 'Expediente', property: 'Record', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Laboratorio Fabricante', property: 'PharmaLaboratoryName', visible: true },
        { title: 'Registro Sanitario', property: 'MedicalRegistration', visible: true },
        { title: 'Fecha Expedición', property: 'FromDate', visible: true },
        { title: 'Fecha Vencimiento', property: 'DefeatDate', visible: true },
        { title: 'Estado Registro Médico', property: 'PharmaRecordStateName', visible: true },
        { title: 'Registro CUM', property: 'CumRecord', visible: true },
        { title: 'Consecutivo CUM', property: 'CumConsecutive', visible: true },
        { title: 'Estado CUM', property: 'PharmaCumState', visible: true },
        { title: 'Cantidad CUM', property: 'CumQuantity', visible: true },
        { title: 'Fecha Activo', property: 'ActiveFromDate', visible: true },
        { title: 'Fecha Inactivo', property: 'ActiveUptoDate ', visible: true },
        { title: 'Muestra Médica', property: 'MedicalSample', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnits', visible: true },
        { title: 'ATC', property: 'AtcCode', visible: true },
        { title: 'Descripción ATC', property: 'AtcDescription', visible: true },
        { title: 'Vía de Administración', property: 'MeansAdministrationName', visible: true },
        { title: 'Concentración', property: 'Concentración', visible: true },
        { title: 'Principio Activo', property: 'ActiveIngredient', visible: true },
        { title: 'Cantidad', property: 'Quantity', visible: true },
        { title: 'Unidad Referencia', property: 'ReferenceUnit', visible: true },
        { title: 'Presentación', property: 'PharmaPresentationName', visible: true },
        { title: 'Laboratorio Representante', property: 'PharmaLaboratoryVendorName', visible: true },
        { title: 'Tipo Role', property: 'PharmaceuticalRolType', visible: true },
        { title: 'Modalidad', property: 'PharmaceuticalModality', visible: true },
        { title: 'IUM', property: 'IUMCode', visible: true },
    ]

    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Medicamento"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                                        <PharmaStateEditor render={form.PharmaRecordStateName} idSelector={form.IDPharmaRecordState} onChange={(e) => { setForm({ ...form, "IDPharmaRecordState": e.IDPharmaRecordState, "PharmaRecordStateName": e.Name }) }}  returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <PharmaLaboratoryEditor render={form.PharmaLaboratoryName} idSelector={form.IDPharmaLaboratory} onChange={(e) => { setForm({ ...form, "IDPharmaLaboratory": e.IDPharmaLaboratory, "PharmaLaboratoryName": e.Name }) }}  returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <PharmaCumStateEditor render={form.PharmaCumState} idSelector={form.IDPharmaCumState} onChange={(e) => { setForm({ ...form, "IDPharmaCumState": e.IDPharmaCumState, "PharmaCumState": e.Name }) }}  returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <MeansAdministrationEditor render={form.MeansAdministrationName} idSelector={form.IDMeansAdministration} onChange={(e) => { setForm({ ...form, "IDMeansAdministration": e.IDMeansAdministration, "MeansAdministrationName": e.Name }) }}  returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <PharmaPresentationEditor render={form.PharmaPresentationName} idSelector={form.IDPharmaPresentation} onChange={(e) => { setForm({ ...form, "IDPharmaPresentation": e.IDPharmaPresentation, "PharmaPresentationName": e.Name }) }}  returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <PharmaLaboratoryEditor render={form.PharmaLaboratoryVendorName} idSelector={form.IDPharmaLaboratoryVendor} onChange={(e) => { setForm({ ...form, "IDPharmaLaboratoryVendor": e.IDPharmaLaboratory, "PharmaLaboratoryVendorName": e.Name }) }} label="Laboratorio Representante" returnType="Object" />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Búsqueda por Texto</label>
                                        <input type="text" className="mb-4 form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                                    </div>
                                    <div className="col-md-4">
                                        <label>Pricipio Activo</label>
                                        <input type="text" className="mb-4 form-control" value={activeIngredient} onChange={(e) => { setActiveIngredient(e.target.value) }} />
                                    </div>
                    <div className="col-md-6 mt-4 p-2">
                        <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDHealthMedication); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}